import {Address} from "@data/schema/loan-appication/address";
import {UserRole} from "@data/schema/account/user-role";


export class AppUser{
   userId: string;
   clientId: string;
   userName: string;
   email: string;
   mobile : string;
   firstName: string;
   lastName: string;
   middleName: string;
   borrower : boolean;
   lastUpdatedAt: Date
   lastUpdatedBy: string;
   deleteFlag: boolean;
   exist : boolean;
   active: boolean;
   error : boolean;
   errorMessage : string;
   role : UserRole;
   customerId : string;
   partnerId : string;
   referralPartnerId : string;


}
